module.exports = __webpack_public_path__ + "img/violet_122.f4c15755.png";